import { render, staticRenderFns } from "./EDMReportTable.vue?vue&type=template&id=6be0328a&scoped=true&"
import script from "./EDMReportTable.vue?vue&type=script&lang=js&"
export * from "./EDMReportTable.vue?vue&type=script&lang=js&"
import style0 from "./EDMReportTable.vue?vue&type=style&index=0&id=6be0328a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0328a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
